// Import polyfills first
import './polyfills';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { auth0Config, validateAuth0Config } from './config/auth0';

const container = document.getElementById('root');
const root = createRoot(container);

// Validate Auth0 configuration
if (!validateAuth0Config()) {
  // Auth0 configuration is missing
}

root.render(
  <Auth0Provider
    domain={auth0Config.domain}
    clientId={auth0Config.clientId}
    authorizationParams={auth0Config.authorizationParams}
    redirectUri={window.location.origin}
    skipRedirectCallback={window.location.pathname === '/callback'}
  >
    <App />
  </Auth0Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
